import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_SCHOOL_DIVISON, LIST_SCHOOL_DIVISON, REMOVE_SCHOOL_DIVISON, UPDATE_SCHOOL_DIVISON, VIEW_SCHOOL_DIVISON } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const schoolDivisonsApi = createApi({
  reducerPath: 'schoolDivisonsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/school/division",
  }),
  tagTypes: ["SchoolDivisons"],
  endpoints: (builder) => ({
    // get Schools list
    getSchoolDivisonList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "title", direction: "ASC" } }) => ({
        method: "PATCH",
        url: LIST_SCHOOL_DIVISON,
        data: {
          search,
          status,
          page,
          limit,
          sort,
        },
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolDivisons", "SchoolDivisonLookup"]
    }),

    // get SchoolDivison profile
    getSchoolDivisonData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${VIEW_SCHOOL_DIVISON}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolDivisons"]
    }),

    // create SchoolDivison profile
    createSchoolDivison: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: CREATE_SCHOOL_DIVISON,
        data
      }),
      invalidatesTags: ["SchoolDivisons"]
    }),

    // update SchoolDivison profile
    updateSchoolDivison: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_SCHOOL_DIVISON}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["SchoolDivisons"]
    }),

    // delete SchoolDivison profile
    deleteSchoolDivison: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_SCHOOL_DIVISON}/${id}`
      }),
      invalidatesTags: ["SchoolDivisons"]
    }),

    schoolDivisonLookup: builder.query({
      query: (id) => ({
        method: "GET",
        url: "/"
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolDivisonLookup"]
    }),
  }),
})

export const {
  useGetSchoolDivisonListQuery,
  useCreateSchoolDivisonMutation,
  useGetSchoolDivisonDataQuery,
  useUpdateSchoolDivisonMutation,
  useDeleteSchoolDivisonMutation,
  useLazyGetSchoolDivisonListQuery,
  useSchoolDivisonLookupQuery,
} = schoolDivisonsApi;